
import React from "react";
import "./Login.css";

function Login() {

    return(
        <div className = 'loginPage'>
            <div className = 'loginPage-heading'>
                <h1>ERROR 404</h1>
            </div>
            {/*<div className = 'loginPage-continer'>*/}
            {/*    <form */}
            {/*        onSubmit = { handleSubmit } */}
            {/*        className = "loginPageForm"*/}
            {/*    >*/}
            {/*        <div className = 'loginPage-container-box'>*/}
            {/*            <label>Email</label>*/}
            {/*            <input */}
            {/*                id = 'loginEmail' */}
            {/*                type = 'text' */}
            {/*                name = "email" */}
            {/*                value = { email }*/}
            {/*                onChange = { (e) => setEmail(e.target.value) }*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        <div */}
            {/*            className = 'loginPage-container-box' */}
            {/*            style = {{*/}
            {/*                position: "relative"*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <label>Password</label>*/}
            {/*                <input*/}
            {/*                    id = 'loginPassword'*/}
            {/*                    type = { !showPassword ? "password" : "text" }*/}
            {/*                    value = { password }*/}
            {/*                    onChange = { (e) => setPassword(e.target.value) }*/}
            {/*                />*/}
            {/*            <span className = "passwordEyeIconBox">*/}
            {/*                {*/}
            {/*                    showPassword ? */}
            {/*                        <VisibilityOffIcon */}
            {/*                            className = { "passwordEyeIcon" }*/}
            {/*                            onClick = { () => setShowPassword(false) }*/}
            {/*                        /> */}
            {/*                        : */}
            {/*                        <RemoveRedEyeIcon */}
            {/*                            className = { "passwordEyeIcon" }*/}
            {/*                            onClick = { () => setShowPassword(true) }*/}
            {/*                        />*/}
            {/*                }*/}
            {/*            </span>*/}
            {/*        </div>*/}
            {/*        {*/}
            {/*            errorLogin ? <p className = "loginErrorMessage">Invalid Email or Password</p> : null*/}
            {/*        }*/}
            {/*        <button */}
            {/*            className = "loginFormSubmitBtn" */}
            {/*            type = { "submit" }*/}
            {/*        >*/}
            {/*            LOG IN*/}
            {/*        </button>*/}
            {/*    </form>*/}
            {/*</div>*/}
        </div>
    )
}

export default Login
